import React from "react";
import {headerSortingClasses, sortCaret} from "../../../_metronic/_helpers";
import moment from "jalali-moment";
import * as columnFormatters from "./column-formatters";
import {useHistory} from "react-router-dom";
import TableLayout from "../../../_metronic/_partials/controls/table/TableLayout";

export default function ProductsTable({
                                          data,
                                          activePage
                                      }) {

    const history = useHistory();

    const handleEdit = (id) => {
        history.push(`/admin/products/${id}`);
    };

    // Table columns
    const columns = [
        {
            dataField: "priority",
            text: "شماره",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "id",
            text: "شناسه محصول",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "brandName",
            text: "برند",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "categoryName",
            text: "دسته بندی",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "price",
            text: "قیمت",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "status",
            text: "وضعیت",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
        },
        {
            dataField: "created_at",
            text: "تاریخ ایجاد",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            formatter: (date) => {
                if (date) {
                    const createdDate = moment(date, 'YYYY-M-D HH:mm:ss').format('jYYYY/jMM/jDD');
                    return <>{createdDate}</>;
                }
            },
        },
        {
            dataField: "action",
            text: "عملیات",
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                openEditPage: handleEdit,
            },
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
        },
    ];

    return (
        <>
            {!!data.data &&
            <TableLayout activePage={activePage} columns={columns} data={data}/>
            }
        </>
    )
}